import * as actions from '../../redux/actions';

import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// const contactByArr = [
//   {
//     image: contactPhoneNoIcon,
//     label: '(+56 2) 2748 6521',
//   },
//   {
//     image: contactMailIcon,
//     label: 'nicasio retamales #44, officina N54 - Estacion Central',
//   },
// ];

function ContactBy({ themes, actions, contactByArr }) {
  return (
    <div className="themes-contact-by">
      <div className="new-container py-60">
        <h2 className="capitalize text-18">communicate</h2>
        <h1 className="capitalize text-30 bold mb-20">con nosotros</h1>
        <div className="contact-by">
          {contactByArr && contactByArr.map(item => (
            <div className="contact-by__item">
              <div className="contact-by__item--icon">
                <img src={item.image} alt="" />
              </div>
              <div className="contact-by__item--label capitalize">{item.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    themes: state.themes,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ContactBy);



// WEBPACK FOOTER //
// ./src/features/themes/common/contactBy/ContactBy.js